import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
})

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
  faUserSecret,
  faRightFromBracket,
  faHandshakeAngle,
  faPeopleGroup,
  faCalendarPlus,
  faCalendarDays,
  faFolderOpen,
  faPenToSquare,
  faTrashCan,
  faXmark,
  faBookOpen,
  faIdCard,
  faCheck,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(
  faUserSecret,
  faRightFromBracket,
  faHandshakeAngle,
  faPeopleGroup,
  faCalendarPlus,
  faCalendarDays,
  faFolderOpen,
  faPenToSquare,
  faTrashCan,
  faXmark,
  faBookOpen,
  faIdCard,
  faCheck,
  faChevronLeft,
  faChevronRight,
)

createApp(App).
  use(store).
  use(router).
  use(vuetify).
  component('font-awesome-icon', FontAwesomeIcon).
  mount('#app')
